import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const CHECKBOX_INDICATOR = 'CheckboxIndicator';
const DefaultIcon = ({ color }) => (_jsx("svg", { width: "12", height: "9", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M1 5.013L3.985 8 11 1", stroke: color || '#000', strokeWidth: "2", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" }) }));
const CheckboxIndicator = (props) => {
    if (!props.checked) {
        return null;
    }
    if (props.style || props.className) {
        return (_jsx("span", { style: props.style ? props.style : {}, className: props.className ? props.className : '', children: props.children || _jsx(DefaultIcon, { color: props.color }) }));
    }
    return _jsx(_Fragment, { children: props.children || _jsx(DefaultIcon, { color: props.color }) });
};
CheckboxIndicator.displayName = CHECKBOX_INDICATOR;
export { CheckboxIndicator };
//# sourceMappingURL=CheckboxIndicator.js.map